<template>
  <div id="home" class="container-fluid">
    <div class="row" id="home-container">
      <google-maps ref="map" style="padding: 0"></google-maps>
      <data-table ref="home_data_table" :parentRefs="this.$refs"></data-table>
    </div>
  </div>
</template>

<script>
import GoogleMaps from 'components/Map'
import DataTable from 'components/Home/DataTable'
export default {
  data() {
    return {
      lists: {

      },
      pollDuctsTimer: undefined,
      pollLeaksTimer: undefined,
      ductosTimer: undefined,
      leaksTimer: undefined,
      ducts: undefined,
    }
  },
  methods: {
    pollDuctsData() {
      this.$store.dispatch('LOAD_DUCTOS').then((data) => {
        this.$refs.home_data_table.fillData()
        this.$refs.map.fillMap();

        if(this.$store.state.user) {
          this.pollDuctsTimer = setTimeout(() => { this.pollDuctsData() }, 3000)
        }
      }).catch(err => {
        if(!this.$store.state.user) {
          this.pollDuctsTimer = setTimeout(() => { this.pollDuctsData() }, 3000)
        }
      })
    },
    pollLeaksData() {
      this.$store.dispatch('LOAD_FUGAS', { current: 1 }).then((data) => {
        if(this.$refs && this.$refs.home_data_table) {
          this.$refs.home_data_table.fillLeaks();
        }
        if(this.$refs && this.$refs.map){
          this.$refs.map.fillLeaks().then(() => {
            if(this.$store.state.user) {
              this.pollLeaksTimer = setTimeout(this.pollLeaksData, 10000);
            }
          });
        }
      }).catch(err => {
        if(!this.$store.state.user) {
            this.pollLeaksTimer = setTimeout(this.pollLeaksData, 10000);
          }
      })
    }
  },
  mounted() {
    this.pollDuctsData();
    this.pollLeaksData();
  },
  beforeDestroy() {
    if(this.pollDuctsTimer) {
      clearTimeout(this.pollDuctsTimer);
    }
    if(this.pollLeaksTimer) {
      clearTimeout(this.pollLeaksTimer);
    }
    this.pollDuctsTimer = null;
    this.pollLeaksTimer = null;
  },
  components: {
    GoogleMaps,
    DataTable,
  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';
#home {
  margin: 0;
  padding: 0;
}
#home-container{
  margin-right: .25rem;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// Home.vue?262cbf60